// import external dependencies
// import './modules/fontawesome'; // TODO: remove if no needed

// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import singleProduct from './routes/singleProduct';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  singleProduct,
});

/** Load Events
 *  https://www.sitepoint.com/jquery-document-ready-plain-javascript/#plainjavascriptreadyalternative
 *  jQuery method provided as reference
 */
const callback = () => routes.loadEvents();

if (
  document.readyState === 'complete' ||
  (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
  callback();
} else {
  document.addEventListener('DOMContentLoaded', callback);
}

$('.sidebar h4').click(function(){
	$(this).parent().toggleClass('close');
});


// WEBPACK FOOTER //
// ./scripts/main.js